export default "__VITE_ASSET__BHGZusNm__"